import React from "react";
import { Navigate } from "react-router-dom";
import { usePagesVisibility } from "../context/PagesContext";

/**
 * Wrap a public route so it 404-redirects to "/" when the admin has marked
 * the page as hidden in the CMS. Home is always rendered (it's the fallback).
 */
export default function PageGuard({ pageKey, children }) {
  const { pages, ready } = usePagesVisibility();
  if (!ready) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-sm font-mono tracking-widest text-text-muted">CARGANDO…</div>
      </div>
    );
  }
  if (!pages[pageKey] && pageKey !== "home") {
    return <Navigate to="/" replace />;
  }
  return children;
}
